import { render, staticRenderFns } from "./WatermarkRemove.vue?vue&type=template&id=7b412694&scoped=true"
import script from "./WatermarkRemove.vue?vue&type=script&lang=js"
export * from "./WatermarkRemove.vue?vue&type=script&lang=js"
import style0 from "./WatermarkRemove.vue?vue&type=style&index=0&id=7b412694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b412694",
  null
  
)

export default component.exports